import { render, staticRenderFns } from "./ProjectRealEstateDomainComAu.vue?vue&type=template&id=5bc6f610"
import script from "./ProjectRealEstateDomainComAu.vue?vue&type=script&lang=ts"
export * from "./ProjectRealEstateDomainComAu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports